import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import constants from "../../assets/constants";
import * as PracticeSessionActions from "../../state/redux/practiceSession";
import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import PracticeAssessmentTemplates from "../widgets/practiceAssessmentTemplates";
import PracticeConversationConfigurations from "../widgets/practiceConversationConfigurations";
import PracticeDetails from "../widgets/practiceDetails";
import PracticePartners from "../widgets/practicePartners";
import PracticePatients from "../widgets/practicePatients";
import PracticeProviders from "../widgets/practiceProviders";
import SelectPractice from "../widgets/selectPractice";

const PracticePortal = props => {
  const { practiceODM, awsGroup } = props;

  return (
    <Portal>
      <PortalAppBar title="Practice Portal" />

      {practiceODM == null && (
        <PortalGridContent>
          <Grid item xs={12} md={3} lg={4} />
          <Grid item xs={12} md={6} lg={4}>
            <SelectPractice />
          </Grid>
          <Grid item xs={12} md={3} lg={4} />
        </PortalGridContent>
      )}
      {practiceODM != null && awsGroup !== constants.userGroups.Creator && (
        <PortalGridContent>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticeDetails />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticePatients />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticeProviders />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticePartners />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticeAssessmentTemplates />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticeConversationConfigurations />
          </Grid>
        </PortalGridContent>
      )}
      {practiceODM != null && awsGroup === constants.userGroups.Creator && (
        // get rid of this eventually
        <PortalGridContent>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticeDetails />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticePatients />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticeProviders />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticePartners />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticeAssessmentTemplates />
          </Grid>
          <Grid item xs={12} sm={6} lg={4}>
            <PracticeConversationConfigurations />
          </Grid>
          <Grid item xs={12}></Grid>
        </PortalGridContent>
      )}
    </Portal>
  );
};

const mapStateToProps = state => ({
  awsGroup: state.userSession.awsGroup,
  practiceODM: state.practiceSession.practiceODM,
});

const mapDispatchToProps = {
  setPracticeODMRequest: PracticeSessionActions.setPracticeODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PracticePortal));
